import { useCallback } from 'react'
import { useSetCalendarEventBriefGenerating } from '@renderer/hooks/use-calendar-events'
import { useTriggerBriefGeneration } from './use-trigger-brief-generation'
import { useBriefRefreshOnSave } from './use-brief-refresh-on-save'
import { useMeetingBrief } from './use-meeting-brief'

/**
 * Exposes create/regenerate actions for the Meeting View brief. Generating
 * state lives on the calendar event; the body comes from `useMeetingBrief`.
 */
export function useBrief(calendarEventId: string | undefined) {
  const setBriefGenerating = useSetCalendarEventBriefGenerating()
  const trigger = useTriggerBriefGeneration()
  const { conversationId } = useMeetingBrief(calendarEventId)
  useBriefRefreshOnSave(conversationId, calendarEventId)

  const triggerMutate = trigger.mutate

  const create = useCallback(() => {
    if (!calendarEventId) return
    setBriefGenerating(calendarEventId, true)
    triggerMutate(calendarEventId, { onError: () => setBriefGenerating(calendarEventId, false) })
  }, [calendarEventId, setBriefGenerating, triggerMutate])

  const regenerate = useCallback(() => {
    if (!calendarEventId) return
    setBriefGenerating(calendarEventId, true)
    triggerMutate({ calendarEventId, regenerate: true }, { onError: () => setBriefGenerating(calendarEventId, false) })
  }, [calendarEventId, setBriefGenerating, triggerMutate])

  return {
    create,
    regenerate,
    isTriggerPending: trigger.isPending,
  }
}
